<template>
  <div class="">
    <v-container fluid>
      <v-card-title>
        <h2
          class="
            text-md-center text-lg-center text-sm-center
            opc_arial
            earth-color
          "
        >
          PAYMENT INFORMATION
        </h2></v-card-title
      >
      <v-form
        @submit.prevent="postBooking()"
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.first_name"
                label="First Name"
                required="required"
                :rules="requiredRules"
                type="text"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.last_name"
                label="Last Name"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.email"
                label="Email"
                required
                type="email"
                :rules="emailRules"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-autocomplete
                label="Country"
                v-model="booking.code"
                :items="allCountries"
                :rules="[(v) => !!v || 'Country is required']"
                required
                item-text="name"
                item-value="code"
                @change="findCountryCode"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.phone"
                label="Phone * (e.g. +XXX...)"
                required
                minlength="13"
                :rules="requiredRules"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.city"
                label="City"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                v-model="booking.promo_code"
                label="Promo Code"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-autocomplete
                label="Mode of Entry"
                v-model="booking.entry_mode"
                :items="allEntryModes"
                item-text="entry_mode_name"
                item-value="entry_mode_public_id"
                @change="findEntryPoints"
                
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-autocomplete
                label="Point of Entry"
                v-model="booking.entry_point"
                :items="allEntryPoints"
                item-text="gate_name"
                item-value="gate_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12 >
            <v-container>
              <v-text-field
                v-model="booking.mode_registration"
                label="Mode registration Number"
              ></v-text-field>
            </v-container>
          </v-flex>
          
          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <v-textarea
                v-model="booking.additional_note"
                label="Additional Note"
              ></v-textarea>
            </v-container>
          </v-flex>
          <v-container v-if="proofOfResidency.length > 0">
            <h4 class="earth-color" @click="residency_proof = true">
              Click Here To Proof Residency
            </h4>
            <v-dialog v-model="residency_proof" persistent max-width="1000px">
              <v-card>
                <v-card-text>
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr
                        v-for="(residency, key) in proofOfResidency"
                        :key="key"
                      >
                        <td>
                          <v-text-field
                            readonly
                            label="Residency"
                            v-model="proofOfResidency[key].payment_person"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            readonly
                            label="Point Of Proof"
                            v-model="proofOfResidency[key].proof_point"
                          ></v-text-field>
                        </td>

                        <td>
                          <v-text-field
                            label="First Name"
                            v-model="proofOfResidency[key].first_name"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            label="Last Name"
                            v-model="proofOfResidency[key].last_name"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            label="Document Id"
                            v-model="proofOfResidency[key].document_id"
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <v-btn
                    :depressed="true"
                    color="primary"
                    @click="addProof()"
                    :loading="$loadingTrue"
                    >Add Proof</v-btn
                  >
                  <v-btn
                    color="red darken-1"
                    flat
                    @click="residency_proof = false"
                    >Close</v-btn
                  >
                </v-card-text>
                <v-card-actions> </v-card-actions>
              </v-card>
            </v-dialog>
          </v-container>

          <v-container>
            <h4 class="earth-color">DONATE TO THE CONSERVANCY</h4>
            <v-layout row wrap>
              <v-flex lg2 md4 sm12 xs12
                ><v-container>
                  <v-autocomplete
                    label="Currency"
                    v-model="donation.currency"
                    :items="allCurrencies"
                    @change="changeCurrencyDonation"
                    :return-object="true"
                    item-text="currency_name"
                    item-value="currency_public_id"
                    :loading="$loadingTrue"
                  ></v-autocomplete> </v-container
              ></v-flex>
              <v-flex lg3 md4 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Amount"
                    v-model="donation.amount"
                    type="number"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md4 sm12 xs12>
                <v-container>
                  <v-autocomplete
                    label="Donate to"
                    v-model="donation.donation_to"
                    :items="publicCauses"
                    :return-object="true"
                    @change="changeCauseDonation"
                    item-text="name"
                    item-value="public_id"
                    menu-props="auto"
                    :loading="$loadingTrue"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg3>
                <v-container>
                  <v-btn :depressed="true" color="primary" @click="passAmount"
                    >Add Donation</v-btn
                  >
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <router-link target="_blank" :to="{ name: 'PTermsAndConditions' }"
                >Ol Pejeta Conservancy terms and conditions</router-link
              >
              <v-checkbox
                v-model="booking.terms"
                type="checkbox"
                label="I agree to the Ol Pejeta Conservancy terms and conditions"
                color="primary"
              >
              </v-checkbox>
              <br />
              <a>Receive Emails and Newsletters</a>
              <v-checkbox
                v-model="booking.newsletter"
                type="checkbox"
                label="I agree to receive promotional emails and newsletters"
                color="primary"
              >
              </v-checkbox>
            </v-container>
          </v-flex>
        </v-layout>
        <v-btn
          :depressed="true"
          color="primary"
          block
          type="submit"
          v-if="booking.terms === true"
          :loading="$loadingTrue"
          >Continue</v-btn
        >
      </v-form>
    </v-container>
    <br />
    {{ conservationFeesProofData }}
  </div>
</template>

<script>
export default {
  name: "booking-information",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      sheet: false,
      residency_proof: false,
      booking: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        code: "",
        country: "",
        city: "",
        additional_note: "",
        promo_code: "",
        newsletter: false,
        country_details: {},
        entry_mode: "",
        entry_point: "",
        mode_registration: "",
      },
      donation: {
        amount: "",
        currency: "",
        donation_to: "",
        cause: "",
        currency_name: "",
      },
      proof: {
        first_name: "",
        last_name: "",
        residency: "",
        document_id: "",
      },
    
    };
  },
  created() {
    this.$store.dispatch("get_page", "t&c");
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_full_conservation_fees");
    this.$store.dispatch("get_all_causes");
    this.$store.dispatch("get_all_gates");
    this.$store.dispatch("get_all_entry_modes");
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.booking.phone = "+" + country.calling_code;
          instance.booking.country_details = country;
        }
      });
    },
    changeCurrencyDonation(name) {
      this.donation.currency = name.currency_public_id;
      this.donation.currency_name = name.currency_name;
    },
    changeCauseDonation(name) {
      this.donation.donation_to = name.public_id;
      this.donation.cause = name.name;
    },

    addProof() {
      this.residency_proof = false;
    },

    passAmount() {
      let donationDetails = [];
      donationDetails.push(this.donation);
      localStorage.setItem("donation", JSON.stringify(donationDetails));
      this.$store.commit("PUBLIC_DONATION", donationDetails);
    },

    postBooking: function () {
      if (this.$refs.form.validate()) {
        var data = {
          guests: this.allConservationFees,
          facilities: this.chosenFacilities,
          inventory: this.chosenInventory,
          vehicles: this.allVehicles,
          donation: this.donation,
          proof_of_residency: this.proofOfResidency,
          external_facilities: this.chosenExternalFacilities,
        };
        var combinedData = Object.assign(
          JSON.parse(localStorage.getItem("user_data")),
          this.booking
        );
        Object.assign(data, combinedData);
        data.currency = this.$store.state.CurrencyStore.browser_currency_id;
        data.currency_id = this.$store.state.CurrencyStore.browser_currency_id;
        localStorage.setItem("previous_booking", JSON.stringify(data));
        this.$store.dispatch("post_booking_public", data);
        this.$store.dispatch("loading_true");
      }
    },
    findEntryPoints: function () {
      this.allEntryPoints;
    },
  },
  computed: {
    allEntryPoints: function () {
      let allEntry = this.allGates;
   
      let res =[]
      if (this.booking.entry_mode != ''){
        
        for(let i = 0; i< allEntry.length; i++ ){
          if (allEntry[i].entry_mode_public_id == this.booking.entry_mode){
            res.push(allEntry[i])
          }
        }
      }
     
      return res;
    },
  },
};
</script>

<style scoped>
</style>
